import { render, staticRenderFns } from "./Stampings.vue?vue&type=template&id=1aadb2c0"
import script from "./Stampings.vue?vue&type=script&lang=js"
export * from "./Stampings.vue?vue&type=script&lang=js"
import style0 from "./Stampings.vue?vue&type=style&index=0&id=1aadb2c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports